@if (hasChats()) {
  <ul class="chat-list">
    <li class="chat-list-expand-button">
      @if (chatListExpanded()) {
        <h3>
          <i aria-hidden="true" class="fa-solid fa-comments"></i>
          <span>{{ 'aiChat.title' | translate }}</span>
        </h3>
      }

      <button
        type="button"
        [title]="(chatListExpanded() ? 'aiChat.reduce' : 'aiChat.expand') | translate"
        (click)="toggleExpand()">
        <i aria-hidden="true" class="fa-regular fa-window-maximize"></i>
      </button>
    </li>

    <li class="chat-list-item chat-list-item-button">
      <button class="chat-list-label" type="button" [title]="'aiChat.newChat' | translate" (click)="newChat()">
        @if (chatListExpanded()) {
          <span>{{ 'aiChat.newChat' | translate }}</span>
        }
        <i aria-hidden="true" class="fa-regular fa-square-plus"></i>
      </button>
    </li>

    @if (chatListExpanded()) {
      <li class="chat-list-item chat-list-item-title">
        <span class="chat-list-item-label">{{ 'aiChat.chats' | translate }}</span>
      </li>
      @for (chat of chats(); track chat.id) {
        @if (chat?.messages?.[0]?.content?.[0]) {
          <li class="chat-list-item chat-list-item-hover" (click)="changeChat(chat.id)">
            <span class="chat-list-item-label">{{ chat.messages[0].content[0] }}</span>
          </li>
        }
      }
    }
  </ul>
}

<div class="chat">
  <ul class="chat-content">
    @defer (when chat()?.messages) {
      @for (message of chat().messages; track message.id) {
        <li class="message" [attr.data-created-by]="message.createdBy">
          <span class="message-date">{{ message.created | date: 'dd/MM/yyyy hh:mm' }}</span>
          <span class="message-content">
            @if (message.content$ | async; as content) {
              {{ content }}
            } @else {
              {{ 'aiChat.thinking' | translate }}
            }
          </span>
        </li>
      } @empty {
        <li class="chat-content-empty">
          <div class="chat-content-empty-container">
            <i aria-hidden="true" class="fa-regular fa-comments"></i>
            <h3>{{ welcomeMessage() }}</h3>
          </div>
        </li>
      }
    } @placeholder {
      <li class="message-loading">
        {{ 'aiChat.loadingMessages' | translate }}
      </li>
    }
  </ul>

  <div class="chat-input">
    <div #wrapper class="textarea-wrapper">
      <textarea
        #area
        type="text"
        [placeholder]="'aiChat.askQuestion' | translate"
        [(ngModel)]="message"
        (input)="wrapper.dataset.replicatedValue = area.value"
        (keydown.enter)="send()"></textarea>
    </div>
    <div class="chat-input-actions">
      <button class="chat-input-action" type="button" [title]="'aiChat.send' | translate">
        <i aria-hidden="true" class="icon-send"></i>
      </button>
    </div>
  </div>
</div>
